export function menuAddEditColumns({ t, mealTypes }) {
  const columns = [
    {
      Header: '№',
      accessor: 'rowNumber',
      width: 60,
      filterable: false
    },
    {
      Header: t('menuPage_day') || 'Дата',
      accessor: 'dayLabel',
      width: 120,
      filterable: false
    },
    // ----------------------------
    {
      Header: t('menu_breakfast') || 'Завтрак',
      accessor: 'breakfast',
      Cell: ({ value }) => (value && value.length ? value.join(', ') : ''),
      filterable: false
    },
    {
      Header: t('menu_secondBreakfast') || 'Второй завтрак',
      accessor: 'secondBreakfast',
      Cell: ({ value }) => (value && value.length ? value.join(', ') : ''),
      filterable: false
    },
    {
      Header: t('menu_lunch') || 'Обед',
      accessor: 'lunch',
      Cell: ({ value }) => (value && value.length ? value.join(', ') : ''),
      filterable: false
    },
    {
      Header: t('menu_snack') || 'Полдник',
      accessor: 'snack',
      Cell: ({ value }) => (value && value.length ? value.join(', ') : ''),
      filterable: false
    }
  ];

  if (mealTypes.dinner) {
    columns.push({
      Header: t('menu_dinner') || 'Ужин',
      accessor: 'dinner',
      Cell: ({ value }) => (value && value.length ? value.join(', ') : ''),
      filterable: false
    });
  }

  if (mealTypes.lateDinner) {
    columns.push({
      Header: t('menu_lateDinner') || 'Поздний ужин',
      accessor: 'lateDinner',
      Cell: ({ value }) => (value && value.length ? value.join(', ') : ''),
      filterable: false
    });
  }

  return columns;
}